export const GET_API_DATA = "GET_API_DATA"
export const DELETE_API_DATA = "DELETE_API_DATA"
export const UPDATE_API_DATA = "UPDATE_API_DATA"